<div style="padding: 10px;">

  <ion-img src="../../../assets/image/manutencao.svg"></ion-img>

  <p class="ion-text-center" style="margin: 30px;">
    {{flagsService.msg_manutencao}}
  </p>
</div>
